/*
export interface Donor {
  name: string;
  user_no: number;
  donor_basic_info: DonorBasicInfo;
  donor_physical_info: DonorPhysicalInfo;
  donor_semen: DonorSemen;
  active_in_hour: number;
}

export interface DonorBasicInfo {
  birth_date: string;
}

export interface DonorPhysicalInfo {
  blood_type: string;
  height: number;
  weight: number;
}

export interface DonorSemen {
  collected_on: string;
  status: string;
  total: string;
}
*/

export const UserType = {
  Donor: "DONOR",
  Donee: "DONEE"
} as const;

// eslint-disable-next-line
export type UserType = typeof UserType[keyof typeof UserType]; // "donor" | "donee"
